module.exports = __webpack_public_path__ + "static/img/pro5_tab1.e9cf6ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/pro5_tab1.jpg
// module id = lYXs
// module chunks = 171